<ng-container *ngIf="isLoading$ | async">

</ng-container>

<router-outlet></router-outlet>